import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9745aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-el" }
const _hoisted_2 = { class: "my-header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "6",
      y: "17.3137",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(-45 6 17.3137)",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "7.41422",
      y: "6",
      width: "16",
      height: "2",
      rx: "1",
      transform: "rotate(45 7.41422 6)",
      fill: "black"
    })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "bg-light" }
const _hoisted_8 = {
  class: "d-flex flex-column scroll-y px-2 width500",
  id: "kt_modal_assign_user_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_assign_user_header",
  "data-kt-scroll-wrappers": "#kt_modal_assign_user_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "card-body p-5" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-12 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-12 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-12 col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "required" }
const _hoisted_23 = { class: "col-lg-12 fv-row" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-lg-12 fv-row" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-12 fv-row" }
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-lg-12 col-form-label required fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-12 fv-row" }
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_40 = {
  type: "submit",
  id: "add_event_submit",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
}
const _hoisted_41 = { class: "indicator-label" }
const _hoisted_42 = { class: "indicator-progress" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isVisible) = $event)),
      title: 'Address',
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      onClose: _ctx.hideDialog,
      onClosed: _ctx.onDialogClosed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Form, {
          id: "kt_modal_assign_user_form",
          onSubmit: _ctx.submit,
          ref: "formRef",
          class: "form mw-650px",
          "initial-values": _ctx.initialValues,
          "validation-schema": _ctx.contactDetailsValidation
        }, {
          header: _withCtx(({ close, titleId, titleClass }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h4", {
                id: titleId,
                class: _normalizeClass(titleClass)
              }, [
                _createTextVNode(_toDisplayString(_ctx.t("pages.site.assignUser")) + " ", 1),
                _createElementVNode("a", {
                  onClick: _withModifiers(
                  () => {
                    close();
                    _ctx.$emit('update:modelValue', false);
                  }
                , ["stop"]),
                  class: "float-end me-n4"
                }, _hoisted_6, 8, _hoisted_4)
              ], 10, _hoisted_3)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t("pages.user.addressLine1")), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        class: "form-control mb-3 mb-lg-0",
                        type: "text",
                        name: "street",
                        modelValue: _ctx.addressLine1,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addressLine1) = $event)),
                        id: "street"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "street" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("pages.user.addressLine2")), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Field, {
                        class: "form-control mb-3 mb-lg-0",
                        type: "text",
                        name: "street2",
                        modelValue: _ctx.addressLine2,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addressLine2) = $event)),
                        id: "street2"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ErrorMessage, { name: "street2" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t("pages.user.country")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Field, {
                        class: "form-control mb-3 mb-lg-0",
                        name: "country",
                        modelValue: _ctx.country,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.country) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.countryId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.countryId) = $event)),
                            clearable: "",
                            filterable: true,
                            "default-first-option": "",
                            placeholder: "Please select country",
                            onChange: _ctx.changeCountry
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryOptions, (option, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: option.label,
                                  value: option.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_ErrorMessage, { name: "country" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["col-lg-12 col-form-label fw-bold fs-6", { required: _ctx.stateOptions.length > 0 }])
                    }, _toDisplayString(_ctx.t("pages.user.state")), 3),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_Field, {
                        class: "form-control mb-3 mb-lg-0",
                        name: "state",
                        modelValue: _ctx.state,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.state,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state) = $event)),
                            clearable: "",
                            filterable: true,
                            "default-first-option": "",
                            placeholder: "Please select state/province/region",
                            onChange: _ctx.changeState,
                            disabled: _ctx.stateOptions.length === 0
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateOptions, (option, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: option.label,
                                  value: option.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_ErrorMessage, { name: "state" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["col-lg-12 col-form-label fw-bold fs-6", { required: _ctx.cityOptions.length > 0 }])
                    }, _toDisplayString(_ctx.t("pages.user.city")), 3),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_Field, {
                        class: "form-control mb-3 mb-lg-0",
                        name: "city",
                        modelValue: _ctx.city,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.city) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.city,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.city) = $event)),
                            clearable: "",
                            filterable: true,
                            "default-first-option": "",
                            placeholder: "Please select city",
                            disabled: _ctx.cityOptions.length === 0
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityOptions, (option, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: option.label,
                                  value: option.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_ErrorMessage, { name: "city" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.t("pages.user.zip")), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_Field, {
                        class: "form-control mb-3 mb-lg-0",
                        type: "text",
                        name: "postalCode",
                        modelValue: _ctx.zip,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.zip) = $event)),
                        id: "postalCode",
                        onInput: _ctx.convertToCapitalCase
                      }, null, 8, ["modelValue", "onInput"]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_ErrorMessage, { name: "postalCode" })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                type: "reset",
                ref: "closeButtonRef",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isVisible = false)),
                class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
              }, _toDisplayString(_ctx.translate("common.close")), 513),
              _createElementVNode("button", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.translate("common.save")), 1),
                _createElementVNode("span", _hoisted_42, [
                  _createTextVNode(_toDisplayString(_ctx.translate("common.pleaseWait")) + " ", 1),
                  _hoisted_43
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "initial-values", "validation-schema"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "onClosed"])
  ]))
}